import { CashRequestDetail } from "@/pages/requests/cash/schema/cash-requests.schema";
import { CheckRequestDetail } from "@/pages/requests/check/schema/check-requests.schema";
import { TransferRequestDetail } from "@/pages/requests/transfer/schema/transfer-requests.schema";
import { ExternalTransferDetail } from "@/pages/requests/external-transfer/schema/external-transfer.schema";
import { ECheqRequestDetail } from "@/pages/requests/echeq/schema/echeq-requests.schema";

interface Props {
  request?:
    | CashRequestDetail
    | CheckRequestDetail
    | TransferRequestDetail
    | ExternalTransferDetail
    | ECheqRequestDetail
    | null;
  type?: string;
  title?: string;
  customTitle?: boolean;
}

export const RequestSectionHeaderTitle = ({ request, type, title, customTitle }: Props) => {
  if (!request) return title || (type ? `Solicitud de ${type}` : "");
  if (customTitle) return title ? `${title} N°: ${request.id}` : String(request.id);
  return request?.id
    ? `Solicitud de ${type} N°: ${request.id}`
    : `Solicitud de ${type}`;
};
